"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payments = void 0;
var react_1 = __importDefault(require("react"));
var Banner_1 = __importDefault(require("./Banner"));
var Methods_1 = __importDefault(require("./Methods"));
var Payments = function (_a) {
    var _b = _a.bannerFullHeight, bannerFullHeight = _b === void 0 ? false : _b;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Banner_1.default, { fullHeight: bannerFullHeight }),
        react_1.default.createElement(Methods_1.default, null)));
};
exports.Payments = Payments;
